
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Editicon from '../../assets/images/dashboardimages/pencil.png'
import addicon from '../../assets/images/dashboardimages/product.png'
import { MDBDataTable, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";
import Searchicon from '../../assets/images/dashboardimages/search.png'
import PostApiCall from "../../Api";
import Notiflix from "notiflix";
export default function JobQrDimensionsList() {
	const [dimensionList, setDimensionList] = useState([]);
	const [searchInput, setSearchInput] = useState('')


	useEffect(() => {
		localStorage.removeItem('QrDeimensions')
		GetJobQrdimensions()
	}, []);

	const GetJobQrdimensions = () => {
		try {
			Notiflix.Loading.Init({
				svgColor: "#777f80",
			});


			Notiflix.Loading.Dots("Please wait...");
			PostApiCall.postRequest({
				whereClause: `where fld_job_type = 'QR Job'`
			}, 'GetJobQrdimensions').then((results) =>
				results.json().then((obj) => {
					if (results.status == 200 || results.status == 201) {
						setDimensionList(obj.data)
						Notiflix.Loading.Remove();
					}
				}))

		} catch (err) {
			console.log(err)
		}
	}



	const PSMData = {
		columns: [
			{
				label: "S.No.",
				field: "serial",
				sort: "disabled",
				width: 150,
			},
			{
				label: "Job Name",
				field: "jobName",
				sort: "disabled",
				width: 400,
			},
			{
				label: "Sheet Height",
				field: "sheetHeight",
				sort: "disabled",
				width: 150,
			},
			{
				label: "Sheet Width",
				field: "sheetWidth",
				sort: "disabled",
				width: 400,
			},

			{
				label: "QR Size",
				field: "qrSize",
				sort: "disabled",
				width: 150,
			},
			{
				label: "Font Size",
				field: "fontSize",
				sort: "disabled",
				width: 150,
			},
			{
				label: "Text Height",
				field: "textHeight",
				sort: "disabled",
				width: 150,
			},


			{
				label: "Action",
				field: "action",
				sort: "disabled",
				width: 100,
			},
		], // end for variant
		rows: dimensionList?.filter((data) => {
			if (!searchInput || typeof searchInput !== 'string') {
				return data;
			}

			const searchInputLower = searchInput.toLowerCase();

			if (
				data.fld_job_name?.toString()
					?.toLowerCase()
					?.includes(searchInputLower) ||
				`${data?.fld_sheet_width != null ? data?.fld_sheet_width?.toString()?.toLowerCase() : ""}`
					?.includes(searchInputLower)
			) {
				return data;
			}

		})?.map((data, i) => {
			// rows: dimensionList?.map((data, i) => {
			return {
				serial: (i + 1),
				jobName: (
					data.fld_job_name
				),
				sheetHeight: (
					data.fld_sheet_height

				),
				sheetWidth: (
					data.fld_sheet_width
				),
				qrSize: (
					data.fld_qr_size
				),
				fontSize: (
					data.fld_font_size
				),
				textHeight: (
					data.fld_text_height
				),




				action: (
					<span>
						<img src={Editicon} alt="View user" className="btnicons" onClick={() => {
							localStorage.setItem(
								"QrDeimensions",
								JSON.stringify(data)
							);
							window.location.href = "/qrcodegenerator";
						}}></img>

					</span>
				)



			}
		})
	}
	return (
		<>
			<div className="page-content">

				<Container fluid>
					<Row className="mt-4">
						<Col xl="12">
							<Card>
								<div className="Bechofy-bg-soft-pink" style={{ height: '60px', }}>
									<div className="row my-1">
										<div className="col-2">
											<div className="form-group">
												<h4 className="FilterCard" style={{ marginTop: '10px' }}>QR Dimensions List</h4>
											</div>
										</div>

										<div className="col-10">
											<div className="position-relative">


												<button
													onClick={() => {
														localStorage.removeItem(
															"QrDeimensions"
														);
														window.location.href = "/qrcodegenerator";
													}}

													className="btn align-items-center btn Bechofy-btn AddNewBtn"
												>
													Add New{" "}
													<span className=""><img src={addicon} alt="block user" className="btnicons" style={{ marginLeft: '5px' }}></img> </span>

												</button>




											</div>
										</div>


									</div>
								</div>





								<CardBody className="pt-0">
									<Row>


										<MDBCol md="12" style={{ marginBottom: "15px", marginTop: '15px' }} >
											<div class="input-group mb-3">


												<div class="input-group-prepend">
													<span class="input-group-text" id="basic-addon1">
														<span className=""><img src={Searchicon} alt="block user" className="btnicons"></img></span></span>
												</div>
												<input type="text" class="form-control" placeholder="Type the search phrase you wish to search within the grid" aria-label="Search" aria-describedby="basic-addon1"
													onChange={(e) => setSearchInput(e.target.value)}
													value={searchInput}

												/>
											</div>
										</MDBCol>

										<Col md="12">

											{PSMData.length !== 0 ?
												<MDBDataTable
													hover
													// scrollY
													striped
													bordered
													data={PSMData}
													seachTop={false}
													entriesOptions={[25, 50, 100]}
													className="printingsheet-master-table"
												>

													<MDBTableHead columns={PSMData.columns} class="printingsheet-master-table" />
													<MDBTableBody rows={PSMData.rows} class="printingsheet-master-table" />
												</MDBDataTable>
												:
												<p>
													No Data Found
												</p>
											}


										</Col>
									</Row>
								</CardBody>
							</Card>


							{/* <WelcomeComp /> */}
						</Col>
					</Row>
				</Container>
			</div>

		</>
	)
}
